import { render, staticRenderFns } from "./suche.vue?vue&type=template&id=09f94c97&scoped=true&"
import script from "./suche.vue?vue&type=script&lang=js&"
export * from "./suche.vue?vue&type=script&lang=js&"
import style0 from "./suche.vue?vue&type=style&index=0&id=09f94c97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f94c97",
  null
  
)

export default component.exports